var Deeplinker = function(serialized) {
    this.links = {};
    if (serialized) this.initWith(serialized);
};

Deeplinker.prototype.initWith = function(serialized) {
    for (var i in serialized) {
        if (serialized[i].indexOf('function') != -1) {
            try {
                /**
                    this hell code is about to deserialize function passed as string (code as a string).
                    cause eval() exposes function into global -> means for nodejs execution - complete disaster.
                    Idea is to create random name function, take from global, delete from global
                */
                var ctx = {};
                var fn = 'fn_' + Math.round(Math.random() * 1000000);
                var dd = 'var ' + fn + ' = ' + serialized[i] + ';';
                function evalInContext() {
                    eval.bind(this)(dd);
                    this.pFn = global[fn];
                    delete global[fn];
                }
                evalInContext.call(ctx);

                this.links[i] = ctx.pFn;
            } catch (e) {}
        } else {
            this.links[i] = serialized[i];
        }
    }
};

Deeplinker.prototype.register = function(action, url) {
    if (typeof url == 'string' && url.indexOf('//') == -1) url = window.location.origin + url;
    this.links[action] = url;
};

Deeplinker.prototype.resolve = function(action, params) {
    var url = this.links[action];

    if (typeof url === 'function') {
        url = url(params);
    }

    if (url) {
        for (var i in params) {
            url = url.replace('${' + i + '}', encodeURIComponent(params[i]));
        }
    }

    return url;
};

Deeplinker.prototype.serialize = function() {
    var links = '';
    for (var i in this.links) {
        links += 'deeplinker[' + i + ']=' + encodeURIComponent(this.links[i].toString().replace(/\n/g, '')) + '&';
    }
    return links;
};

module.exports = Deeplinker;



/** WEBPACK FOOTER **
 ** ../src/widgets/helpers/Deeplinker.js
 **/